import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articles } from '@/mocks/articles';

const articlesSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '新葡京娱乐城 - 最新资讯',
  description: '新葡京娱乐城最新资讯，涵盖行业动态、游戏攻略、优惠活动、平台公告等内容。',
  url: 'https://sportsinn.github.io/articles',
};

export default function Articles() {
  return (
    <>
      <SchemaOrg schema={articlesSchema} />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '最新资讯' }]} />

        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新资讯
            </h1>
            <p className="text-sm text-foreground-500 mb-10">
              了解新葡京娱乐城最新动态、游戏攻略与优惠活动
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article) => (
                <article key={article.id}>
                  <Link
                    to={`/article/${article.id}`}
                    className="group block bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
                  >
                    <div className="relative h-52 overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                        title={article.title}
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="text-xs px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 whitespace-nowrap">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-400">
                          {article.publishDate}
                        </span>
                      </div>
                      <h2 className="text-lg font-semibold text-foreground-900 mb-3 line-clamp-2 leading-snug">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                        {article.summary}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-foreground-400">
                          {article.author}
                        </span>
                        <span className="text-xs text-foreground-400 flex items-center gap-1">
                          <i className="ri-eye-line text-sm"></i>
                          {article.readCount.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}